// =============================================================================
// MÓDULO COUNTDOWN TIMER
// =============================================================================

export class CountdownTimer {
    constructor(element, config = {}) {
        this.element = element;
        this.config = {
            targetDate: config.targetDate || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
            timezone: config.timezone || 'America/Argentina/Buenos_Aires',
            labels: {
                days: 'días',
                hours: 'horas',
                minutes: 'min',
                seconds: 'seg',
                ...config.labels
            },
            onComplete: config.onComplete || this.defaultOnComplete.bind(this),
            updateInterval: config.updateInterval || 1000,
            ...config
        };

        this.init();
    }

    init() {
        if (!this.element) return;

        // Crear estructura HTML si no existe
        this.createHTML();
        
        // Iniciar el timer
        this.startTimer();
    }

    createHTML() {
        if (this.element.children.length === 0) {
            this.element.innerHTML = `
                <div class="unit" data-aos="zoom-in" data-aos-delay="100">
                    <div class="num" id="days">00</div>
                    <div class="lab">${this.config.labels.days}</div>
                </div>
                <div class="unit" data-aos="zoom-in" data-aos-delay="200">
                    <div class="num" id="hours">00</div>
                    <div class="lab">${this.config.labels.hours}</div>
                </div>
                <div class="unit" data-aos="zoom-in" data-aos-delay="300">
                    <div class="num" id="minutes">00</div>
                    <div class="lab">${this.config.labels.minutes}</div>
                </div>
                <div class="unit" data-aos="zoom-in" data-aos-delay="400">
                    <div class="num" id="seconds">00</div>
                    <div class="lab">${this.config.labels.seconds}</div>
                </div>
            `;
        }

        // Obtener elementos
        this.daysEl = this.element.querySelector('#days');
        this.hoursEl = this.element.querySelector('#hours');
        this.minutesEl = this.element.querySelector('#minutes');
        this.secondsEl = this.element.querySelector('#seconds');
    }

    startTimer() {
        this.updateTimer();
        this.interval = setInterval(() => this.updateTimer(), this.config.updateInterval);
    }

    updateTimer() {
        const now = new Date().getTime();
        const target = new Date(this.config.targetDate).getTime();
        const difference = target - now;

        if (difference > 0) {
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            this.updateDisplay(days, hours, minutes, seconds);
        } else {
            this.updateDisplay(0, 0, 0, 0);
            this.config.onComplete();
            clearInterval(this.interval);
        }
    }

    updateDisplay(days, hours, minutes, seconds) {
        if (this.daysEl) this.daysEl.textContent = this.padZero(days);
        if (this.hoursEl) this.hoursEl.textContent = this.padZero(hours);
        if (this.minutesEl) this.minutesEl.textContent = this.padZero(minutes);
        if (this.secondsEl) this.secondsEl.textContent = this.padZero(seconds);
    }

    padZero(num) {
        return num.toString().padStart(2, '0');
    }

    defaultOnComplete() {
        this.element.innerHTML = `
            <div class="unit">
                <div class="num">🎉</div>
                <div class="lab">¡Es hoy!</div>
            </div>
        `;
    }

    destroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
}